var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMail = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 16.9996V8.06999C1 7.40128 1.3342 6.77682 1.8906 6.40589L8.8906 1.73922C9.5624 1.29135 10.4376 1.29135 11.1094 1.73922L18.1094 6.40589C18.6658 6.77682 19 7.40128 19 8.06999V16.9996M1 16.9996C1 18.1042 1.89543 18.9996 3 18.9996H17C18.1046 18.9996 19 18.1042 19 16.9996M1 16.9996L7.75 12.4996M19 16.9996L12.25 12.4996M1 7.99962L7.75 12.4996M19 7.99962L12.25 12.4996M12.25 12.4996L11.1094 13.26C10.4376 13.7079 9.5624 13.7079 8.8906 13.26L7.75 12.4996",
    stroke: "#575656",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mail.4ce3615c.svg";
export { ForwardRef as ReactComponent };